<div class="modal-header">
  <h4 class="modal-title faqModal__title">
    @if (faq) {
      Editar pregunta
    }

    @if (!faq) {
      Nueva pregunta
    }
  </h4>
  <button
    type="button"
    class="btn-close"
    aria-label="Cerrar"
    (click)="activeModal.dismiss('Cross click')">
  </button>
</div>

<div class="modal-body faqModal">
  @if (!loading) {
    <form
      id="formFaq"
      [formGroup]="formFaq"
      (ngSubmit)="onSubmit()">
      <div class="container-fluid px-0">
        <div class="row">

          <!-- Contexto y datos derivados: texto de solo lectura FUERA de los
               inputs, nunca precargados dentro de un campo editable. -->
          <div class="col-12 mb-4">
            <div class="faqModal__meta">

              <p class="faqModal__metaRow d-flex mb-1">
                <span class="faqModal__metaLabel">Grupo</span>
                <span class="faqModal__metaValue text-truncate">
                  {{ faqGroup.title }}
                </span>
              </p>

              @if (!faqGroup.status) {
                <p class="faqModal__metaRow d-flex mb-1">
                  <span class="faqModal__metaLabel">Aviso</span>
                  <span class="faqModal__metaValue faqModal__metaValue--off">
                    El grupo está oculto en la app, así que esta pregunta no se
                    mostrará aunque quede activa.
                  </span>
                </p>
              }

              @if (faq) {
                <p class="faqModal__metaRow d-flex mb-1">
                  <span class="faqModal__metaLabel">ID</span>
                  <span class="faqModal__metaValue text-truncate">
                    {{ faq.faqId }}
                  </span>
                </p>

                <p class="faqModal__metaRow d-flex mb-0">
                  <span class="faqModal__metaLabel">Actualizada</span>
                  <span class="faqModal__metaValue text-truncate">
                    {{ faq.updatedAt | dateToMoment: 'DD MMM YYYY HH:mm' }}
                  </span>
                </p>
              }

            </div>
          </div>

          <!-- ---------------------------------------------------------------- -->
          <!--                        ANCHOR QUESTION                           -->
          <!-- ---------------------------------------------------------------- -->
          <div class="col-12 form-group mb-4">
            <label htmlFor="faqQuestion" class="form-label">
              {{ dataForm['question'].label }}
            </label>
            <input
              id="faqQuestion"
              type="text"
              class="form-control"
              formControlName="question"
              [placeholder]="dataForm['question'].placeholder ?? dataForm['question'].label"
              [attr.aria-invalid]="submitted && f['question'].errors ? 'true' : null"
              [attr.aria-describedby]="submitted && f['question'].errors ? 'faqQuestionError' : 'faqQuestionHelp'"
              [ngClass]="{
                'is-invalid': submitted && f['question'].errors
              }">

            <!-- Contador derivado: fuera del input, como texto de apoyo. -->
            <div class="d-flex justify-content-between gap-2 mt-1">
              <span id="faqQuestionHelp" class="faqModal__help">
                Es el texto de la tarjeta en la pantalla de Ayuda.
              </span>
              <span
                class="faqModal__counter"
                [ngClass]="{
                  'faqModal__counter--over': (f['question'].value?.length ?? 0) > questionMaxLength
                }">
                {{ f['question'].value?.length ?? 0 }}/{{ questionMaxLength }}
              </span>
            </div>

            @if (submitted && f['question'].errors) {
              <div class="invalid-feedback d-block" id="faqQuestionError">
                @if (f['question'].errors!['required']) {
                  <div>{{ dataForm['question'].requiredMessage }}</div>
                }
                @if (f['question'].errors!['maxlength']) {
                  <div>La pregunta no puede tener más de {{ questionMaxLength }} caracteres.</div>
                }
              </div>
            }
          </div>

          <!-- ---------------------------------------------------------------- -->
          <!--                         ANCHOR ANSWER                            -->
          <!-- ---------------------------------------------------------------- -->
          <div class="col-12 form-group mb-4">
            <label htmlFor="faqAnswer" class="form-label">
              {{ dataForm['answer'].label }}
            </label>
            <textarea
              id="faqAnswer"
              rows="6"
              class="form-control faqModal__textarea"
              formControlName="answer"
              [placeholder]="dataForm['answer'].placeholder ?? dataForm['answer'].label"
              [attr.aria-invalid]="submitted && f['answer'].errors ? 'true' : null"
              [attr.aria-describedby]="submitted && f['answer'].errors ? 'faqAnswerError' : 'faqAnswerHelp'"
              [ngClass]="{
                'is-invalid': submitted && f['answer'].errors
              }"></textarea>

            <span id="faqAnswerHelp" class="faqModal__help d-block mt-1">
              Los saltos de línea se respetan tal cual en la app.
            </span>

            @if (submitted && f['answer'].errors) {
              <div class="invalid-feedback d-block" id="faqAnswerError">
                @if (f['answer'].errors!['required']) {
                  <div>{{ dataForm['answer'].requiredMessage }}</div>
                }
              </div>
            }
          </div>

          <!-- ---------------------------------------------------------------- -->
          <!--                        ANCHOR VIDEO URL                          -->
          <!-- ---------------------------------------------------------------- -->
          <div class="col-12 form-group mb-4">
            <label htmlFor="faqVideoUrl" class="form-label">
              {{ dataForm['videoUrl'].label }}
            </label>
            <input
              id="faqVideoUrl"
              type="url"
              class="form-control"
              formControlName="videoUrl"
              [placeholder]="dataForm['videoUrl'].placeholder ?? dataForm['videoUrl'].label"
              aria-describedby="faqVideoUrlHelp">

            <span id="faqVideoUrlHelp" class="faqModal__help d-block mt-1">
              Déjalo vacío si la pregunta no tiene video. Si lo borras aquí,
              también se borra en la app.
            </span>
          </div>

          <!-- ---------------------------------------------------------------- -->
          <!--                          ANCHOR STATUS                           -->
          <!-- ---------------------------------------------------------------- -->
          <div class="col-12 mb-2">
            <div class="faqModal__switchRow d-flex align-items-center justify-content-between gap-3">

              <div class="faqModal__switchText">
                <label htmlFor="faqStatus" class="form-label mb-0">
                  {{ dataForm['status'].label }}
                </label>
                <p class="faqModal__help mb-0">
                  @if (f['status'].value) {
                    La pregunta se muestra dentro de su grupo.
                  } @else {
                    La pregunta queda oculta para los residentes.
                  }
                </p>
              </div>

              <p-inputSwitch
                inputId="faqStatus"
                formControlName="status">
              </p-inputSwitch>

            </div>
          </div>

        </div>
      </div>
    </form>
  }
</div>

<div class="modal-footer">
  <div class="col-12 my-3">
    <button
      (click)="activeModal.close()"
      type="button"
      class="btn btn-outline-danger w-100 faqModal__actionBtn">
      Cancelar
    </button>
  </div>
  <div class="col-12">
    <!-- Nunca deshabilitado: la validación se resuelve en onSubmit(). -->
    <button
      type="submit"
      form="formFaq"
      class="btn btn-primary w-100 faqModal__actionBtn">
      {{ faq ? 'Actualizar' : 'Registrar' }}
    </button>
  </div>
</div>
